import { useEffect, useState } from "react";
import { baliPhotoUrl } from "@/lib/baliInfoPhotos";

type NaturePhotoProps = {
  src: string;
  alt: string;
  onOpen: (src: string, alt: string) => void;
};

/**
 * Kleines Vorschaubild. Nimmt zuerst das Foto aus dem eigenen Speicher.
 * Fehlt es dort noch, wird automatisch das Original der alten Seite geladen,
 * damit nie eine leere Kachel stehen bleibt.
 */
export default function NaturePhoto({ src, alt, onOpen }: NaturePhotoProps) {
  const localSrc = baliPhotoUrl(src);
  const [current, setCurrent] = useState(localSrc);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setCurrent(localSrc);
    setFailed(false);
  }, [localSrc]);

  if (failed) return null;

  return (
    <button
      type="button"
      onClick={() => onOpen(current, alt)}
      className="relative w-full h-28 md:h-32 rounded-md overflow-hidden bg-background-200 cursor-pointer group"
    >
      <img
        src={current}
        alt={alt}
        className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        onError={() => {
          if (current !== src) {
            setCurrent(src);
          } else {
            setFailed(true);
          }
        }}
      />
      <span className="absolute bottom-1.5 right-1.5 w-6 h-6 flex items-center justify-center rounded-full bg-foreground-950/50 text-background-50 opacity-0 group-hover:opacity-100 transition-opacity">
        <i className="ri-zoom-in-line text-xs"></i>
      </span>
    </button>
  );
}